
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"300","height":"334.667","viewBox":"0 0 225 251"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M95.4 9.5c-13.9 3-26.1 9.6-37.1 19.9-13.2 12.4-21.9 28.9-24.2 45.9-.6 4.5-1.1 24.1-1.1 46v38.2l-10.1 10C10.4 182 9 184.4 9 194.8c0 8.6 1.7 12.4 7.1 16.5 4.2 3.1 9.7 3.6 37.2 3.7 19.9 0 25.7.3 25.7 1.2 0 .7 1.3 4 2.9 7.3 12.1 25.2 47.5 25.4 60.1.3 1.6-3.4 3-6.7 3-7.5 0-1 5-1.3 26.3-1.3 27.2 0 32.3-.6 36.6-3.8 5.4-4 7.1-7.8 7.1-16.3 0-4.3-.5-9-1.1-10.5-.5-1.6-5.9-7.8-12-13.9L191 159.4v-39c0-22.4-.5-41.7-1.1-45.4-2.8-17.5-10-31.3-22.8-44-12-11.8-23.7-18.3-38.9-21.5-8.3-1.8-24.7-1.8-32.8 0zm31.5 15.1c17 4.2 33.9 17.4 41.4 32.4 7 13.9 7 13.7 7.6 63 .7 51.9-.8 45.8 14.5 61 9.1 9 9.6 9.7 9.6 13.7v4.3H24v-4.3c0-4 .5-4.7 9.6-13.7 15.3-15.2 13.8-9.1 14.5-61 .6-49.3.6-49.1 7.6-63C63.1 42.3 79.3 29.4 96 24.9c8.3-2.3 22.4-2.4 30.9-.3zm2.1 191.9c0 .8-1.7 3.2-3.8 5.3-7.6 7.6-18.8 7.6-26.4 0-6.6-6.6-6.1-6.8 13.2-6.8 14.4 0 17 .2 17 1.5z"}})])
          )
        }
      }
    